import {IMaskFormatter} from './IMaskFormatter';

export class DateMask implements IMaskFormatter {
    public dividers: string[];
    public inputElement: any;
    public placeholder = 'MM/DD/YYYY';
    static shortDateMask = '**/**/****';
    public captureCaret;

    // returns the model value restricting it to numbers with slashes(/) appended.
    getModelValue(event, value): string {
        let modelValue = value;
        for (var i = 0; i < this.dividers.length; i++) {
            while (modelValue.indexOf(this.dividers[i]) > -1) {
                modelValue = modelValue.replace(this.dividers[i], '');
            }
        }

        if (modelValue.length !== 0) {
            if (modelValue.match(/^[0-9]*$/)) {   // Accepts only the numbers
                return modelValue;
            } else {
                modelValue = modelValue.toString();  // Removes the non numeric character
                return modelValue.slice(0, -1);
            }
        }

        return modelValue;
    }

    // Jumps the caret poition to the end of the digits.
    setCaretOnClick(model: string): void {
        console.log(model.length);
        if (model.length <= 2) {
            this.inputElement.setSelectionRange(model.length, model.length);
        } else if (model.length > 2 && model.length <= 4) {
            this.inputElement.setSelectionRange(model.length + 1, model.length + 1);
        } else if (model.length > 4 && model.length <= 8) {
            this.inputElement.setSelectionRange(model.length + 2, model.length + 2);
        }
    }

    // Jumps the input caret based on the position. Drives the user to next input location.
    setCaret(model: string, event: any): void {

        let caretPos = model.length;
        let test;
        let rest;
        if (model.length !== 0) {
            if (model.length >= 2 && model.length <= 3) {
                caretPos++;
            }
            if (model.length >= 4) {
                caretPos = caretPos + 2;
            }
        } else {
            caretPos = 0;
        }
        if (this.inputElement !== null) {
            if (this.inputElement.createTextRange) {
                const range = this.inputElement.createTextRange();
                range.move('character', caretPos);

                range.select();
            } else {
                if (this.inputElement.selectionStart) {
                    this.inputElement.focus();
                    this.inputElement.setSelectionRange(caretPos, caretPos);
                } else {
                    this.inputElement.focus();
                }
            }
        }

        if (event.which === 8 && model.length === 4) {  // backspace operation escaping the slashes
            this.inputElement.setSelectionRange(5, 5);
        }
        if (event.which === 8 && model.length === 2) {
            this.inputElement.setSelectionRange(2, 2);
        }
    }

    // transforms to  '  /  /   '
    padString(str: string) {
        const pad = '        ';
        return (str + pad).substring(0, pad.length);
    }

    restrictInput(modelValue: string): boolean {
        // user cannot enter more than 8 values viz 'MM/DD/YYYY'
        if (modelValue) {
            return modelValue.length <= 7;
        }
    }

    // TODO- If user clicks at random places and deletes (We are skipping this for now and handling it in 'setCaretOnClick')
    // performDeletion(model: string, event: any, captureCaret: any): string {
    //    if (event.which === 8 && this.captureCaret !== 0 && model.length < 8) {
    //        console.log('Input Element range!', captureCaret);
    //        model = [model.slice(0, this.captureCaret), " ", model.slice(this.captureCaret)].join('');
    //        this.inputElement.setSelectionRange(this.captureCaret - 1, this.captureCaret - 1);
    //        return model;
    //    }
    // }
}
